import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingIndicatorService {
  private readonly isLoading = new BehaviorSubject<boolean>(false);
  private activeRequests = 0;
  private loadingTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly DELAY_MS = 300;

  show(): void {
    this.isLoading.next(true);
  }

  hide(): void {
    this.isLoading.next(false);
  }

  isVisible$(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  isVisible(): boolean {
    return this.isLoading.getValue();
  }

  incrementRequests(): void {
    this.activeRequests++;

    // Only start the timer if this is the first request
    if (this.activeRequests === 1) {
      this.loadingTimeout = setTimeout(() => {
        if (this.activeRequests > 0 && !this.isVisible()) {
          this.show();
        }
      }, this.DELAY_MS);
    }
  }

  decrementRequests(): number {
    this.activeRequests = Math.max(0, this.activeRequests - 1);

    if (this.activeRequests === 0) {
      // Cancel the timer if it hasn't fired yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      if (this.isVisible()) {
        this.hide();
      }
    }

    return this.activeRequests;
  }

  reset(): void {
    this.activeRequests = 0;

    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }

    if (this.isVisible()) {
      this.hide();
    }
  }
}
